import { IGridViewState, TLatestPost } from './types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TProject } from '../project/types'
import { getPostsForInstaGridViewThunk } from './thunks'
import { SOCIAL_NETWORK } from '../../models/post'
import { TPost } from '../managePost/types'

const initialState: IGridViewState = {
  [SOCIAL_NETWORK.INSTAGRAM_SOCIAL]: {
    latestPosts: []
  },
  loaders: {
    getPosts: false
  }
}

const gridViewSlice = createSlice({
  name: 'gridView',
  initialState,
  reducers: {
    setProjectsAction: (state, action: PayloadAction<TProject[]>) => {
      state[SOCIAL_NETWORK.INSTAGRAM_SOCIAL].latestPosts = []
    },
    resetGridViewStateAction: (state) => initialState
  },
  extraReducers: (builder) => {
    // create agency
    builder.addCase(getPostsForInstaGridViewThunk.pending, (state, action) => {
      state.loaders.getPosts = true
    })
    builder.addCase(
      getPostsForInstaGridViewThunk.fulfilled,
      (state, action: PayloadAction<TLatestPost[]>) => {
        state.loaders.getPosts = false
        state[SOCIAL_NETWORK.INSTAGRAM_SOCIAL].latestPosts = action.payload
      }
    )
    builder.addCase(getPostsForInstaGridViewThunk.rejected, (state, action) => {
      state.loaders.getPosts = false
    })
  }
})

export const { resetGridViewStateAction } = gridViewSlice.actions
export default gridViewSlice.reducer
